import React from "react";
import Separator from "@/shared/Separator";
import { ParentGrid, ContainerAniversaryDoubleContainer } from "./style";
import { GridStyleColor } from "@/widgets/Container/Templates/stylesGridGeneric.js";

const ContainerAniversaryDouble = (props) => {
  const { link, sectionClass = "", title, title1, link1, title2, link2, title3, link3, title4, link4, linkImage } = props;
  
  const marfeelTitle = title ? "ContainerAniversaryDouble-"+title?.normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/\s+/g, '-')
  .toLowerCase() : "ContainerAniversaryDouble";

  const titlesExtras = [];
  if(title1 && link1) titlesExtras.push({title: title1, link: link1})
  if(title2 && link2) titlesExtras.push({title: title2, link: link2})
  if(title3 && link3) titlesExtras.push({title: title3, link: link3})
  if(title4 && link4) titlesExtras.push({title: title4, link: link4})

  return (
    props.content?.length > 0 && (
      <ContainerAniversaryDoubleContainer>
        {title && (
          <Separator
            title={title}
            link={link}
            sectionClass={sectionClass}
            extras={titlesExtras}
            linkImage={linkImage}
          />
        )}
        <GridStyleColor id={marfeelTitle} >
          <ParentGrid
            data-mrf-recirculation={`${marfeelTitle}`}
            className={`ContainerAniversaryDouble module-grid ${sectionClass}`}
          >
            {props.content?.map((item, index) => {
              return (
                  <div
                    className={`div${index + 1} card`}
                    key={`container${index}`}
                  >
                    {props.renderContainerWidgetCallback(
                        index + 1,
                        props.positionProperties?.[index]?.templateNews ??
                          "NewsAniversary",
                        { containerName: "ContainerAniversaryDouble" }
                      )}
                  </div>
                
              );
            })}
           </ParentGrid>
        </GridStyleColor>
      </ContainerAniversaryDoubleContainer>
    )
  );
};
export default ContainerAniversaryDouble;